// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smooth-visibility{transition:all .3s ease}.smooth-visibility.hidden{opacity:0}`, "",{"version":3,"sources":["webpack://./src/app/components/smoothVisibility/index.scss"],"names":[],"mappings":"AAAA,mBACE,uBAAA,CAEA,0BACE,SAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
